import type { TableData } from './types';

export const getChangedAmount = (services: TableData[]): number => {
  return services.filter(
    (service) => service.newPrice !== service.originalPrice,
  ).length;
};
